/* global module */

/**
 * Services                                                                                                 Directives - Web Components
 * ************************************************************************************************************************************
 */
const angular = require('angular');
var app = angular.module('learn-services', []);


require('./services/access');
require('./services/access-helper');
require('./services/analytics-provider');
require('./services/application');
require('./services/assessment-lib');
require('./services/assessment-charts');
require('./services/auth-interceptor');
require('./services/authorization');
require('./services/company-configuration');
require('./services/bulk-users');
require('./services/confetti-generator');
require('./services/content-auth');
require('./services/content-reference');
require('./services/custom-copy');
require('./services/features');
require('./services/froala-options');
require('./services/intercom');
require('./services/languages');
require('./services/linked-video-data');
require('./services/messaging');
require('./services/navigation');
require('./services/notifications');
require('./services/nps');
require('./services/storage');
require('./services/survey-helper');
require('./services/track-organization');
require('./services/url-lookup');
require('./services/zendesk-widget');
require('./services/i18n');

/**
 * Browserify Module export
 * @type angular module @exp;app
 */
module.exports = app;
